import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './styles/App.css';

// Hooks
import { useTheme } from './hooks/useTheme';

// Components
import ThemeToggle from './components/ThemeToggle';
import Navbar from './components/Navbar';
import HomePage from './components/HomePage';
import BlogPage from './components/BlogPage';
import DuatGame from './components/DuatGame';

// Data
import { navLinks } from './data/personal';

function App() {
  const { theme, toggleTheme } = useTheme();

  return (
    <Router>
      <div className="App">
        <ThemeToggle theme={theme} toggleTheme={toggleTheme} />
        <Navbar navLinks={navLinks} />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/duat" element={<DuatGame />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
